export default __webpack_public_path__ + "static/media/marauders-map-v4-01-02.527a65fb.jpg";